export * from './common-passenger-detail-form-data';
export * from './common-passenger-detail-form.controller';
export * from './common-passenger-detail-form.component';
